/* Hide the quantity picker only if a visible Dealeasy tier-pricing block exists */
(() => {
  // Nur auf Produktseiten laufen
  const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
  if (!productForm) return;

  // Deine Mengen-Picker – inkl. <quantity-input>
  const qtySelectors = () =>
    document.querySelectorAll(
      'quantity-input, .product-form__input--quantity, .product-form__quantity, .quantity, [data-quantity]'
    );

  // Sehr spezifisch nach dem Dealeasy-Block suchen (nur wenn er auch wirklich sichtbar ist)
  const isVisible = (el) => !!(el && el.offsetParent !== null);

  const findDealeasyBlock = () => {
    // typische Shopify-Block-IDs der App (wie auf deinem Screenshot)
    const candidates = [
      '[id^="shopify-block"][id*="dealeasy"]',
      '[id*="dealeasy_v"]',
      '[id*="aure_dealeasy"]',
      '.dealeasy-widget',
      '[data-dealeasy]'
    ]
      .map((sel) => document.querySelector(sel))
      .filter(isVisible);

    // Außerdem prüfen wir, ob in diesem Block echte Tier-Optionen stehen (Radio-Buttons / Karten)
    for (const block of candidates) {
      if (!block) continue;
      const hasTiers =
        block.querySelector('input[type="radio"]') ||
        block.querySelector('[class*="tier"]') ||
        block.querySelector('[class*="card"]') ||
        block.textContent.match(/Buy\s+\d+/i); // "Buy 10–19" etc.
      if (hasTiers && isVisible(block)) return block;
    }
    return null;
  };

  const update = () => {
    const dealeasyBlock = findDealeasyBlock();
    const hideQty = !!dealeasyBlock;

    qtySelectors().forEach((el) => {
      el.style.display = hideQty ? 'none' : '';
      el.setAttribute('data-dealeasy-hidden', hideQty ? 'true' : 'false');
    });
  };

  // sofort & bei nachträglichem Laden prüfen
  update();
  const mo = new MutationObserver(update);
  mo.observe(document.body, { childList: true, subtree: true });
})();